export default __webpack_public_path__ + "images/851081936ad4723a8730539c9fbce1c0-race-track.png";